import { useEffect } from 'react';
import { css } from '@emotion/react';
import { WeavePortalLogo } from '@frontend/assets';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { useAuth } from '../../providers/auth.provider';
import { createFileRoute } from '../../utils/route-factory';

const Component = () => {
  const { login, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) location.href = '/location'; // TODO: *** Will be updated just default
  }, []);

  return (
    <div
      css={css`
        align-items: center;
        display: flex;
        flex: 1;
        background-color: ${theme.colors.neutral5};
        justify-content: center;
        min-height: 100vh;
      `}
    >
      <main
        css={css`
          border: 1px solid ${theme.colors.neutral20};
          border-radius: ${theme.borderRadius.medium};
          display: flex;
          flex-direction: column;
          justify-content: center;
          background-color: ${theme.colors.white};
          padding: ${theme.spacing(5)};
        `}
      >
        <WeavePortalLogo subText='Wam' />

        <div
          css={css`
            display: flex;
            flex-direction: column;
            width: ${theme.spacing(43)};
          `}
        >
          <Button
            variant='primary'
            css={css`
              margin: ${theme.spacing(2, 0)};
            `}
            onClick={login}
          >
            Log In
          </Button>
        </div>
      </main>
    </div>
  );
};

export const Route = createFileRoute({ path: '/sign-in/', component: Component, type: 'public' });
